import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Label,
} from "reactstrap";
import Shimmer from "react-shimmer-effect";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { YearSelect, MonthSelect } from "../../../../helpers/ui/YearSelect";
import { accessRole } from "../../../../helpers/access_role";
import { Preview, generateFormData } from "../../../../helpers/ui/FileInput";
import Select from "../../../../helpers/ui/CustomSelect";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";
import { cancelToken } from "../../../../services/adapters/kepegawaian/menuService";

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import IndexBloc from "../Index/Blocs/IndexBloc";
import UpdateBloc from "./Blocs/UpdateBloc";
import moment from "moment";

class UpdateView extends Component {
  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";
  peg_nip = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_nip
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_nip
    : "";

  updateBloc = new UpdateBloc();
  indexBloc = new IndexBloc();
  source;
  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      rankOption: [],
      signatoriesOption: [],
      detail: [],
      rankFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 50,
        sort_order: {
          column: "rank_id",
          order: "asc",
        },
      },
      signatoriesFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 50,
        sort_order: {
          column: "signatories_official_id",
          order: "asc",
        },
      },
      decree_cp3k_signatories_official_name: "",
      decree_cp3k_signatories_official_nip: "",
      decree_cp3k_adjustment_signatories_official_name: "",
      decree_cp3k_adjustment_signatories_official_nip: "",
      optionStatusApproval: [
        { label: "Disetujui", value: 1 },
        { label: "Ditolak", value: 2 },
      ],
    };
  }

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        decree_cp3k_uuid: this.props.id,
        employee_nip: this.peg_nip,
        decree_cp3k_employee_uuid: this.peg_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, "document");
    await this.updateBloc.fetchApprove(formData);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  loadDetail = async () => {
    const query = {
      uuid: this.props.id,
      history: 1,
    };
    await this.indexBloc.fetchDetail(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadDetail();
  };

  componentDidMount() {
    this.setTokenAPI();

    this.indexBloc.detailChannel.subscribe((result) => {
      const data = result.data.response;
      let response_current = result.data.response.current;
      let response_history = result.data.response.history;
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            detail: response_current,
            history: response_history,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.approveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    const queryParams = new URLSearchParams(window.location.search);

    /* 
            If Administrator
            Set Employee Selected on localstorage by Notification Click 
        */
    try {
      let causer = queryParams.get("causer");

      if (causer != null) {
        let arrCauser = atob(causer).split("|");

        let dataUser = {
          employee_uuid: arrCauser[1],
          employee_name: arrCauser[0],
          employee_current_position_name: arrCauser[2],
          employee_nip: arrCauser[3],
        };
        localStorage.setItem("employeeSelected", JSON.stringify(dataUser));
        //console.log(arrCauser);
      }
    } catch (error) {}
  }

  componentWillUnmount() {
    this.updateBloc.approveChannel?.unsubscribe();
  }

  render() {
    const { detail } = this.state;
    const { result, total } = this.state.rankOption;
    const signatoriesResult = this.state.signatoriesOption?.result;
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="skcp3k" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Approve SK Cp3k</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    {this.state.history ? (
                      <Row className="mb-3">
                        <label className="col-md-3"></label>
                        <Col md="5">
                          <strong> Data Baru </strong>
                        </Col>
                        <Col md="4">
                          <strong className="text-danger"> Data Lama </strong>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Golongan Ruang <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.rank_group_room !== ""
                              ? this.state.detail.rank_group_room
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.rank_group_room !== ""
                              ? this.state.history.rank_group_room
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Nomor SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_decree_number !== ""
                              ? this.state.detail.decree_cp3k_decree_number
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.decree_cp3k_decree_number !== ""
                              ? this.state.history.decree_cp3k_decree_number
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Tanggal SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_decree_date !== ""
                              ? this.dateParse(
                                  this.state.detail.decree_cp3k_decree_date
                                )
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.decree_cp3k_decree_date !== ""
                              ? this.dateParse(
                                  this.state.history.decree_cp3k_decree_date
                                )
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        TMT SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_decree_tmt !== ""
                              ? this.dateParse(
                                  this.state.detail.decree_cp3k_decree_tmt
                                )
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.decree_cp3k_decree_tmt !== ""
                              ? this.dateParse(
                                  this.state.history.decree_cp3k_decree_tmt
                                )
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <div
                      style={{
                        width: "100%",
                        border: "1px solid rgb(179, 185, 191)",
                        borderRadius: 4,
                        padding: 10,
                      }}
                    >
                      <Label>Pejabat Penetap SK Cp3k</Label>
                      <hr />

                      <Row className="mb-3">
                        <Label className="col-md-2">
                          Nama Pejabat Penetap{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Col md="5">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_signatories_official_name !== ""
                                ? this.state.detail
                                    .decree_cp3k_signatories_official_name
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                        <Col md="4">
                          {this.state.history ? (
                            <>
                              {this.state.history
                                .decree_cp3k_signatories_official_name !== ""
                                ? this.state.history
                                    .decree_cp3k_signatories_official_name
                                : "-"}
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-2">
                          NIP Pejabat Penetap{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Col md="5">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_signatories_official_nip !== ""
                                ? this.state.detail
                                    .decree_cp3k_signatories_official_nip
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                        <Col md="4">
                          {this.state.history ? (
                            <>
                              {this.state.history
                                .decree_cp3k_signatories_official_nip !== ""
                                ? this.state.history
                                    .decree_cp3k_signatories_official_nip
                                : "-"}
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </div>

                    <Row className="mb-3 mt-3">
                      <Label className="col-md-2">
                        Masa Kerja Awal <span className="text-danger">*</span>
                      </Label>
                      <Col md="2">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_year_period !== ""
                              ? this.state.detail.decree_cp3k_year_period +
                                " Tahun"
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="3">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_month_period !== ""
                              ? this.state.detail.decree_cp3k_month_period +
                                " Bulan"
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="2">
                        {this.state.history ? (
                          <>
                            {this.state.history.decree_cp3k_year_period !== ""
                              ? this.state.history.decree_cp3k_year_period +
                                " Tahun"
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col md="2">
                        {this.state.history ? (
                          <>
                            {this.state.history.decree_cp3k_month_period !== ""
                              ? this.state.history.decree_cp3k_month_period +
                                " Bulan"
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Tanggal Tugas <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_assignment_date !==
                            ""
                              ? this.dateParse(
                                  this.state.detail.decree_cp3k_assignment_date
                                )
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.decree_cp3k_assignment_date !==
                            ""
                              ? this.dateParse(
                                  this.state.history.decree_cp3k_assignment_date
                                )
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Nomor Nota <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_nota_number !== ""
                              ? this.state.detail.decree_cp3k_nota_number
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="5">
                        {this.state.history ? (
                          <>
                            {this.state.history.decree_cp3k_nota_number !== ""
                              ? this.state.history.decree_cp3k_nota_number
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Tanggal Nota <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_nota_date !== ""
                              ? this.dateParse(
                                  this.state.detail.decree_cp3k_nota_date
                                )
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.decree_cp3k_nota_date !== ""
                              ? this.dateParse(
                                  this.state.history.decree_cp3k_nota_date
                                )
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <div
                      style={{
                        width: "100%",
                        border: "1px solid rgb(179, 185, 191)",
                        borderRadius: 4,
                        padding: 10,
                      }}
                    >
                      <Label>Penyesuaian Masa Kerja</Label>
                      <hr />

                      <Row className="mb-3">
                        <Label className="col-md-2">
                          No. SK <span className="text-danger">*</span>
                        </Label>
                        <Col md="5">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_decree_number !== ""
                                ? this.state.detail
                                    .decree_cp3k_adjustment_decree_number
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                        <Col md="5">
                          {this.state.history ? (
                            <>
                              {this.state.history
                                .decree_cp3k_adjustment_decree_number !== ""
                                ? this.state.history
                                    .decree_cp3k_adjustment_decree_number
                                : "-"}
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-2">
                          Tanggal SK <span className="text-danger">*</span>
                        </Label>
                        <Col md="5">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_decree_date !== ""
                                ? this.dateParse(
                                    this.state.detail
                                      .decree_cp3k_adjustment_decree_date
                                  )
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                        <Col md="4">
                          {this.state.history ? (
                            <>
                              {this.state.history
                                .decree_cp3k_adjustment_decree_date !== ""
                                ? this.dateParse(
                                    this.state.history
                                      .decree_cp3k_adjustment_decree_date
                                  )
                                : "-"}
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-2">
                          TMT SK <span className="text-danger">*</span>
                        </Label>
                        <Col md="5">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_decree_tmt !== ""
                                ? this.dateParse(
                                    this.state.detail
                                      .decree_cp3k_adjustment_decree_tmt
                                  )
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                        <Col md="4">
                          {this.state.history ? (
                            <>
                              {this.state.history
                                .decree_cp3k_adjustment_decree_tmt !== ""
                                ? this.dateParse(
                                    this.state.history
                                      .decree_cp3k_adjustment_decree_tmt
                                  )
                                : "-"}
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-2">
                          Pejabat Penetap <span className="text-danger">*</span>
                        </Label>
                        <Col md="5">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_signatories_official_name !==
                              ""
                                ? this.state.detail
                                    .decree_cp3k_adjustment_signatories_official_name
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                        <Col md="4">
                          {this.state.history ? (
                            <>
                              {this.state.history
                                .decree_cp3k_adjustment_signatories_official_name !==
                              ""
                                ? this.state.history
                                    .decree_cp3k_adjustment_signatories_official_name
                                : "-"}
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-2">
                          Masa Kerja Awal <span className="text-danger">*</span>
                        </Label>
                        <Col md="3">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_year_period !== ""
                                ? this.state.detail
                                    .decree_cp3k_adjustment_year_period +
                                  " Tahun"
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                        <Col md="2">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_month_period !== ""
                                ? this.state.detail
                                    .decree_cp3k_adjustment_month_period +
                                  " Bulan"
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                        <Col md="2">
                          {this.state.history ? (
                            <>
                              {this.state.history
                                .decree_cp3k_adjustment_year_period !== ""
                                ? this.state.history
                                    .decree_cp3k_adjustment_year_period +
                                  " Tahun"
                                : "-"}
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                        <Col md="2">
                          {this.state.history ? (
                            <>
                              {this.state.history
                                .decree_cp3k_adjustment_month_period !== ""
                                ? this.state.history
                                    .decree_cp3k_adjustment_month_period +
                                  " Bulan"
                                : "-"}
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </div>

                    <Row className="mb-3 mt-3">
                      <Label className="col-md-2">File Pendukung</Label>
                      <Col md="5">
                        <Preview value={detail?.document} />
                      </Col>
                      <Col md="4">
                        <Preview value={this.state.history?.document} />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <label className="col-md-3">
                        Status Approval <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <Select
                          name="status_approval"
                          errorMessage="Pilih Status Approval"
                          options={this.state.optionStatusApproval}
                          placeholder="Pilih Status Approval"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="status_approval_description"
                        className="col-md-3 col-form-label"
                      >
                        Keterangan Approval{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="status_approval_description"
                          placeholder="Keterangan Approval..."
                          type="textarea"
                          errorMessage="Masukkan Keterangan Approval"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="status_approval_description"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to={`/kepegawaian/home.html?skcp3k`}>
                          <Button color="danger" type="button">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to={`/kepegawaian/home.html?skcp3k`} />
        ) : null}
      </Fragment>
    );
  }
}

export default UpdateView;
